import React, { FC } from "react";
import { Tabs } from "antd";
import { TabsStyled } from "./elements";
const { TabPane } = Tabs;

type Props = {
  tabs: { title: string | JSX.Element; content: JSX.Element }[];
  onTabClick?: (key: string, event: any) => void;
  defaultActiveKey?: string;
};

const Tab: FC<Props> = ({ tabs, onTabClick, defaultActiveKey }) => {
  return (
    <TabsStyled
      type="card"
      onTabClick={onTabClick}
      defaultActiveKey={defaultActiveKey}
    >
      {tabs.map((tab: any, index: number) => (
        <TabPane tab={tab.title} key={index}>
          {tab.content}
        </TabPane>
      ))}
    </TabsStyled>
  );
};

export default Tab;
